import { useLocation } from 'react-router-dom';
import { initialLoadings } from '@/data/arrivalsData';
import { actionQueue } from '@/lib/actionQueue';

// Views of a page, shown as sub-items in the sidebar (desktop) and as chips (mobile).
// The first view lives at the page's own URL. Views with `group: 'setup'` are not daily
// work and are shown apart under "Nastavení plánu"; `count: 'actions'` carries the queue size.
export const subViews = {
  '/kamiony': [
    { key: 'today', path: '/kamiony', label: 'arrivals.tabToday' },
    { key: 'actions', path: '/kamiony/akce', label: 'actions.title', count: 'actions' },
    { key: 'map', path: '/kamiony/mapa', label: 'trucks.siteMap' },
    { key: 'import', path: '/kamiony/import', label: 'import.title', group: 'setup' },
    { key: 'sources', path: '/kamiony/zdroje', label: 'sources.title', group: 'setup' },
  ],
  '/statistiky': [
    { key: 'overview', path: '/statistiky', label: 'stats.tab.overview' },
    { key: 'carriers', path: '/statistiky/dopravci', label: 'stats.tab.carriers' },
    { key: 'urgency', path: '/statistiky/urgence', label: 'stats.tab.urgency' },
    { key: 'site', path: '/statistiky/areal', label: 'stats.tab.site' },
    { key: 'reports', path: '/statistiky/reporty', label: 'stats.tab.reports' },
  ],
};

// Size of today's work queue at the start of the day (same rule as the Akce view).
export const actionCount = actionQueue(initialLoadings).length;

// Views that show today's loadings; setup views (import, sources) do not.
export const isDailyView = (view) => view.group !== 'setup';

export const isInSection = (pathname, base) => pathname === base || pathname.startsWith(`${base}/`);

// Base path of the page with views the URL belongs to, or null.
export const sectionOf = (pathname) => Object.keys(subViews).find(base => isInSection(pathname, base)) || null;

// Current view of `base`; unknown sub-paths fall back to the first view.
export const currentView = (pathname, base) => {
  const views = subViews[base];
  return views.find(v => v.path === pathname) || views[0];
};

// Key of the current view of the page at `base`.
export function useSubView(base) {
  const { pathname } = useLocation();
  return currentView(pathname, base).key;
}
